const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const {pageModuleTable} = require("../../../shared/PageShared");
const {requiresFullDocumentNavigation} = require("../../../shared/ElevRoutes");
const URLMake = require("../../../shared/URLMake");

const ErrorUtil = require("../../../shared/ErrorUtil");
const AT = require("../vault/ActionTypes");
const OpsPage = require("../vault/OpsPage");
const OpsUser = require("../vault/OpsUser");
const Bundles = require("../Bundles");
const ScrollUtil = require("../util/ScrollUtil");
const withBundleLoading = require("../hoc/withBundleLoading");
const withVaultDispatch = require("../hoc/withVaultDispatch");

const LoadGuard = require("../view/LoadGuard");
const LoadState = require("../vault/util/LoadState");
const UserLoadError = require("../view/UserLoadError");
const ErrorMessage = require("../view/ErrorMessage");

const ProtectedView = require("./ProtectedView");
const Page404 = require("./Page404");
const PagePostSignin = require("./PagePostSignin");
const PageHome = require("../home/PageHome");
const {PageOnboarding} = require("../home/PageOnboarding");

// Components that PageComponent can render without loading a bundle. Must also
// have a corresponding entry in PageShared's pageModuleTable.
const corePageComponents = {
	Page404,
	PageHome,
	PageOnboarding,
	PagePostSignin,
};

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withBundleLoading(Component);
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "PageComponent",

		propTypes: {
			scrollToTopWhenNewPage: PT.bool,
			//Info from the vault that must be passed down from its parent
			user: PT.object.isRequired,
			page: PT.object.isRequired,
			connected: PT.bool.isRequired,
			additionalBundles: PT.array,

			// Injected by HOCs
			demoData: PT.object,
			requireOrLoadBundle: PT.func.isRequired,
			dispatch: PT.func.isRequired,
		},

		UNSAFE_componentWillUpdate: function(nextProps) {
			this.isNewPage = this.props.page.name !== nextProps.page.name;
		},

		componentDidUpdate: function() {
			let newScrollTo = this.nextScrollTo;
			if (!newScrollTo && this.isNewPage && this.props.scrollToTopWhenNewPage) {
				newScrollTo = "top";
			}
			ScrollUtil.scrollTo(newScrollTo);
			this.nextScrollTo = null;
		},

		loadUser: function() {
			this.props.dispatch({
				type: AT.LOAD_USER_REQUEST,
				userID: this.props.user.userID,
			});
		},

		setNextScrollTo: function(pos) {
			this.nextScrollTo = pos;
			// Force update soon if componentDidUpdate isn't called until later
			setTimeout(() => {
				if (this.nextScrollTo) {
					ScrollUtil.scrollTo(this.nextScrollTo);
					this.nextScrollTo = null;
				}
			}, 100);
		},

		// Does some error handling on bundles still waiting to load. Returns
		// a status aggregating the ones of all the other bundles.
		getStatusOfWaitingBundles: function(bundleNameList) {
			let finalStatus = "done";
			bundleNameList.forEach(bundleName => {
				const bundleExports = this.props.requireOrLoadBundle(bundleName);
				if (bundleExports) return;

				const status = Bundles.getStatus(bundleName);
				finalStatus = LoadState.reduceStatus(finalStatus, status);

				if (status === "error" || status === "done") {
					Bundles.markFailed(bundleName, () => {
						const message =
							status === "done"
								? `Bundle ${bundleName} marked with status done but has no exports in PageComponent`
								: `Bundle ${bundleName} did not load`;
						const error = Bundles.getError(bundleName);

						ErrorUtil.log("E_BUNDLE_FAILED", message, error);
					});
				}
			});
			return finalStatus;
		},

		// Computes the React class to render for this page. May return null or a
		// React element when still waiting or handling errors.
		getComponent: function(page) {
			const pageInfo = pageModuleTable[page.name];
			if (!pageInfo) {
				return null;
			}

			// Special case: office.main has both an elev route (for logged-out users)
			// and a React component (for logged-in users). Only redirect if we know
			// the user is NOT logged in (load complete and not authenticated/initialized).
			// Uninitialized Platform users should see the marketing homepage.
			const {user} = this.props;
			const isOfficeMain = page.name === "office.main";
			const isUserInitialized = user && OpsUser.isInitialized(user);
			const shouldRedirect = !(
				isOfficeMain &&
				(!user ||
					user.load !== "done" ||
					(user.authenticated && isUserInitialized))
			);

			if (requiresFullDocumentNavigation(page) && shouldRedirect) {
				// This logic is usually taken care of by the Router. We add this here
				// to take care of rare cases of direct vault.state.page manipulation
				// without going through a link.
				if (!this._elevRedirect && typeof window !== "undefined") {
					this._elevRedirect = true;
					window.location = URLMake.forPageState(page);
				}
				return null;
			}

			const [bundleName, moduleName] = pageInfo;
			if (!bundleName) {
				return corePageComponents[moduleName];
			}

			// Last case is that it's an external bundle we may have to load.
			const additional = this.props.additionalBundles || [];
			const waitingBundles = [bundleName, ...additional];
			const finalStatus = this.getStatusOfWaitingBundles(waitingBundles);
			const bundleExports = this.props.requireOrLoadBundle(bundleName);
			if (finalStatus === "done" && bundleExports) {
				return bundleExports[moduleName];
			} else if (finalStatus === "error") {
				return (
					<ErrorMessage
						standardMessage="refresh"
						isOffice={OpsPage.isOfficePage(page)}
						isFull={true}
					/>
				);
			}
		},

		render: function() {
			const {user, page} = this.props;
			const Component = this.getComponent(page);

			if (!Component) {
				return null;
			} else if (React.isValidElement(Component)) {
				return Component;
			}

			let renderedView = (
				<Component
					{...page}
					user={user}
					setNextScrollTo={this.setNextScrollTo}
				/>
			);

			const isLoggedIn = OpsUser.isLoggedIn(user);
			const protectedPage = OpsPage.isPageProtected(page);
			const isDefinitelyNotLoggedIn = OpsUser.isDefinitelyNotLoggedIn(user);
			const userLoadError = (
				<UserLoadError
					error={user.loadError}
					connected={this.props.connected}
					isOffice={OpsPage.isOfficePage(page)}
				/>
			);

			// If no authentication, this should only be the login page
			// If there is authentication, show the loadguard
			if (global.PLAY_PROBLEM_DATA) {
				// Skip loading the user on the baeditor iframe.
			} else if (isDefinitelyNotLoggedIn && protectedPage) {
				// Auth explicitly failed (user.notLoggedIn = true)
				if (OpsPage.isOfficePage(page)) {
					return <ProtectedView type={"notLoggedIn"} />;
				} else {
					//Don't need anything here, should be redirected to login.
					return null;
				}
			} else if (protectedPage && user.load === "done" && !user.authenticated) {
				// fixed issue where it was checking !loggedIn instead of notLoggedIn essentially
				// so it was flashing the not logged view when the user was still loading
				// User load completed successfully but they're not authenticated
				if (OpsPage.isOfficePage(page)) {
					return <ProtectedView type={"notLoggedIn"} />;
				} else {
					//Don't need anything here, should be redirected to login.
					return null;
				}
			} else if (isLoggedIn && OpsPage.isPageForNotLoggedIn(page)) {
				// If user is not logged in, we'll find out shortly when authentication
				// fails or the user loads. Wait to show the page until then.
				if (user.load === "error") {
					return userLoadError;
				}
				return null;
			} else if (isLoggedIn && OpsPage.checkBadPermissions(user, page)) {
				// If the user is logged in but does not have permissions to view the
				// page Should only trigger for office page
				return <ProtectedView type={"badPermissions"} user={user} />;
			} else {
				// Load the user if needed. Show the rendered view after loading if
				// protected, or show it always if not protected via noGuard.
				renderedView = (
					<LoadGuard
						identifier={"user" + user.userID}
						status={user}
						noGuard={!protectedPage}
						requestLoad={this.loadUser}
						loadingView="logo"
						logoColorType="white"
						errorView={userLoadError}
					>
						{renderedView}
					</LoadGuard>
				);
			}
			return renderedView;
		},
	})
);
